var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.187 21.0288L32.6798 31.9339C32.4875 32.1013 32.2468 32.1927 31.9983 32.1927C31.7499 32.1927 31.5091 32.1013 31.3168 31.9339L18.8025 21.0288C19.4234 20.5334 20.1785 20.2656 20.9546 20.2656H43.0349C43.811 20.2656 44.5661 20.5334 45.187 21.0288ZM32.0002 34.4827C32.7463 34.4827 33.4694 34.2077 34.0465 33.7046L46.464 22.8758C46.5962 23.2781 46.6641 23.7012 46.6648 24.1273V39.8783C46.6639 40.9001 46.2819 41.8798 45.6027 42.6023C44.9236 43.3248 44.0027 43.7311 43.0422 43.7321H20.9547C19.9942 43.7311 19.0733 43.3248 18.3941 42.6023C17.715 41.8798 17.333 40.9001 17.332 39.8783V24.1273C17.3328 23.7012 17.4007 23.2781 17.5329 22.8758L29.954 33.7046C30.531 34.2077 31.2541 34.4827 32.0002 34.4827Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIc);
export default __webpack_public_path__ + "static/media/mail-ic.efbeacd56da571e4809ac3a62042ec0c.svg";
export { ForwardRef as ReactComponent };